module.exports = __webpack_public_path__ + "img/lv.9c8f0c56.svg";